import { render } from "./createFAQsDialog.vue?vue&type=template&id=b164b20a&scoped=true"
import script from "./createFAQsDialog.vue?vue&type=script&lang=js"
export * from "./createFAQsDialog.vue?vue&type=script&lang=js"

import "./createFAQsDialog.vue?vue&type=style&index=0&id=b164b20a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b164b20a"]])

export default __exports__